<script>
    export let searchTerm;
    export let setSearchTerm;
</script>

<div class="searchContainer">
    <input
        type="text"
        placeholder="Search our resources"
        class="search"
        on:input={({ target: { value } }) => setSearchTerm(value)}
        value={searchTerm}
    />
</div>
